import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Switch } from "@/components/ui/switch";

const KEY = "ym_cookie_consent";

export const getConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch {
    return null;
  }
};

const save = (functional, analytics) => {
  localStorage.setItem(KEY, JSON.stringify({ necessary: true, functional, analytics, date: new Date().toISOString() }));
  window.dispatchEvent(new Event("cookie-consent-changed"));
};

export function CookieBanner() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [manage, setManage] = useState(false);
  const [functional, setFunctional] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (!c) setOpen(true);
    const reopen = () => {
      const cur = getConsent();
      setFunctional(!!cur?.functional);
      setAnalytics(!!cur?.analytics);
      setManage(true);
      setOpen(true);
    };
    window.addEventListener("open-cookie-settings", reopen);
    return () => window.removeEventListener("open-cookie-settings", reopen);
  }, []);

  if (!open || pathname.startsWith("/admin")) return null;

  const finish = (f, a) => {
    save(f, a);
    setOpen(false);
    setManage(false);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-50 no-print" data-testid="cookie-banner">
      <div className="rounded-lg border border-[#D4AF37]/30 bg-[#1F1411]/95 backdrop-blur-xl p-5 text-[#FDFBF7] shadow-2xl">
        <div className="flex items-center gap-2 mb-2">
          <Cookie size={18} className="text-[#D4AF37]" />
          <p className="font-display tracking-[0.14em] text-sm">Çerez Tercihleri</p>
        </div>
        <p className="text-xs text-[#CBBBAE] leading-relaxed">
          Sitemizin çalışması için zorunlu çerezler kullanıyoruz. Onayınızla işlevsel ve analitik çerezler de
          kullanılabilir. Detaylar için{" "}
          <Link to="/yasal/cerez-politikasi" className="text-[#D4AF37] underline" data-testid="cookie-policy-link">Çerez Politikası</Link>
          {" "}ve{" "}
          <Link to="/yasal/kvkk-aydinlatma-metni" className="text-[#D4AF37] underline" data-testid="cookie-kvkk-link">KVKK Aydınlatma Metni</Link>.
        </p>
        {manage && (
          <div className="mt-4 space-y-3 text-xs" data-testid="cookie-manage-panel">
            <div className="flex items-center justify-between"><span>Zorunlu çerezler</span><Switch checked disabled /></div>
            <div className="flex items-center justify-between"><span>İşlevsel çerezler (harita vb.)</span><Switch checked={functional} onCheckedChange={setFunctional} data-testid="cookie-functional-switch" /></div>
            <div className="flex items-center justify-between"><span>Analitik çerezler</span><Switch checked={analytics} onCheckedChange={setAnalytics} data-testid="cookie-analytics-switch" /></div>
          </div>
        )}
        <div className="mt-4 flex flex-wrap gap-2">
          <button onClick={() => finish(true, true)} className="btn-gold !px-4 !py-2 !text-xs" data-testid="cookie-consent-accept-btn">Tümünü Kabul Et</button>
          <button onClick={() => finish(false, false)} className="btn-ghost-gold !px-4 !py-2 !text-xs" data-testid="cookie-consent-reject-btn">Yalnızca Zorunlu</button>
          {manage ? (
            <button onClick={() => finish(functional, analytics)} className="btn-ghost-gold !px-4 !py-2 !text-xs" data-testid="cookie-consent-save-btn">Seçimi Kaydet</button>
          ) : (
            <button onClick={() => setManage(true)} className="text-xs text-[#CBBBAE] underline px-2" data-testid="cookie-consent-manage-btn">Tercihleri Yönet</button>
          )}
        </div>
      </div>
    </div>
  );
}
